import React, { memo } from "react";
import ReactSelect, { components } from "react-select";
import { isMobile } from "../../helperFunc";

const CustomSelect = memo((props) => {
  const {
    className = "",
    placeholder = "Select",
    outerStyles = {},
    customComponents = {},
    isClearable = false,
    selectArrow, // Single arrow image used for both up and down state
    crossIcon,
    menuPlacement = "auto",
    menuPosition = "absolute",
    disabled,
    noOptionsMessage = () => "No options found",
  } = props;
  const reactSelectStyles = {
    input: (base) => ({ ...base, fontSize: isMobile ? 14 : 16 }),
    placeholder: (base) => ({
      ...base,
      fontSize: isMobile ? 12 : 14,
      fontWeight: 400,
      color: "#B8BDBD",
    }),
    singleValue: (base) => ({ ...base, fontSize: isMobile ? 12 : 14 }),
    control: (base) => {
      return {
        ...base,
        ...commonControlStyles,
        border: `1px solid #EEEEEE`,
        ":hover": {
          border: `1px solid #EEEEEE`,
        },
      };
    },
  };
  const commonControlStyles = {
    height: "40px",
    backgroundColor: "#FFFFFF",
    outline: "none",
    boxShadow: "none",
    borderTopLeftRadius: "0px",
  };
  const deskCommonControlStyles = {
    height: 32,
    minHeight: "32px",
    backgroundColor: "#FFFFFF",
    fontSize: "14px",
    fontWeight: 400,
    lineHeight: "19px",
    outline: "none",
    boxShadow: "none",
    borderTopLeftRadius: "0px",
    borderBottomLeftRadius: "0px",
  };
  // Custom MultiValue Remove Icon
  const MultiValueRemove = (props) => (
    <components.MultiValueRemove {...props}>
      {crossIcon && <img src={crossIcon} alt="Remove" />}
    </components.MultiValueRemove>
  );

  // Dropdown Indicator: Single arrow image, rotated if open
  const DropdownIndicator = (props) => {
    const rotationStyle = {
      transform: props.selectProps.menuIsOpen
        ? "rotate(180deg)"
        : "rotate(0deg)",
      transition: "transform 0.2s ease",
    };

    return (
      <components.DropdownIndicator {...props}>
        {selectArrow && (
          <img
            src={selectArrow}
            alt="Toggle Arrow"
            style={{ width: "20px", height: "20px", ...rotationStyle }}
          />
        )}
      </components.DropdownIndicator>
    );
  };

  // Optional Indicator Separator
  const IndicatorSeparator = () => <span />;

  // Default and customizable styles
  const defaultStyles = {
    option: (provided, state) => ({
      ...provided,
      borderBottom: "1px solid #EEEEEE",
      color: "#333333",
      backgroundColor: state.isFocused ? "#DFECE9" : "#fff",
      cursor: !isMobile && "pointer",
    }),
    multiValue: (base) => ({
      ...base,
      backgroundColor: "#DFECE9",
      borderRadius: "40px",
      alignItems: "center",
      fontSize: 12,
    }),
    multiValueRemove: (base) => ({
      ...base,
      height: "100%",
    }),
    control: (base, state) => ({
      ...base,
      backgroundColor: "#FFFFFF",
      border: "1px solid #EEEEEE",
      outline: "none",
      boxShadow: state.isFocused ? "0 0 0 2px #DFECE9" : "none",
      ":hover": {
        borderColor: "#EEEEEE !important",
      },
    }),
    multiValueLabel: (base) => ({ ...base, fontSize: 12, color: "#0E5B48" }),
    input: (base) => ({ ...base, color: "#0E5B48", fontSize: 12 }),
    menu: (base) => ({ ...base, boxShadow: "unset" }),
    menuList: (base) => ({
      ...base,
      boxShadow: "0px 4px 8px rgba(0, 0, 0, 0.1)",
      border: "1px solid #EEEEEE",
      borderRadius: "4px",
      padding: 0,
      maxHeight: isMobile ? "150px" : "300px",
    }),
  };

  return (
    <ReactSelect
      placeholder={placeholder}
      isDisabled={disabled}
      isClearable={isClearable}
      noOptionsMessage={noOptionsMessage}
      components={{
        MultiValueRemove,
        DropdownIndicator,
        IndicatorSeparator,
        ...customComponents,
      }}
      styles={outerStyles ? { ...outerStyles } : { ...defaultStyles }}
      menuPlacement={menuPlacement}
      menuPosition={menuPosition}
      {...props}
      className={`${
        isMobile ? "font-size14 line-height16" : "font-size16 line-height19"
      } placeholderColorb8bdbd ${className}`}
    />
  );
});

export default CustomSelect;
